import React,{Component} from 'react'

export default class TxtIntro2 extends Component{
  render(){
    return(
      <>
        <div class="text-intro">
          <div class="container">
            <h1 class="text-center ">{this.props.TxtIntro_title}</h1>
            <p class="text-center text-intro-p txt-all-intro">{this.props.TxtIntro_description}</p>
          </div>
        </div>
      </>
    );
  }
 
}